module.exports = __webpack_public_path__ + "img/3.e0b4fd12.svg";